import { createDefaultTextStyle } from "./textStyle";

const createId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const createDefaultHeroCta = (overrides = {}) => ({
  id: createId(),
  text: "View Inventory",
  link: "/inventory",
  textStyle: createDefaultTextStyle(),
  ...overrides,
});

/** Normalize legacy single CTA fields into a `ctas` array. */
export const buildHeroCtasPatch = (ctas = []) => {
  const next = Array.isArray(ctas) ? ctas : [];
  return {
    ctas: next,
    ctaText: next[0]?.text ?? "",
    ctaLink: next[0]?.link ?? "",
    ctaTextStyle: next[0]?.textStyle,
  };
};

export const normalizeHeroCtas = (data = {}) => {
  // An existing (even empty) array means the user manages CTAs explicitly;
  // an empty array is a deliberate "no CTAs" choice.
  if (Array.isArray(data.ctas)) {
    return data.ctas.map((cta) => ({
      id: cta.id || createId(),
      text: cta.text || "",
      link: cta.link || "",
      textStyle: cta.textStyle || createDefaultTextStyle(),
      textColor: cta.textColor,
    }));
  }

  if (data.ctaText || data.ctaLink) {
    return [
      createDefaultHeroCta({
        text: data.ctaText || "View Inventory",
        link: data.ctaLink || "/inventory",
        textStyle: data.ctaTextStyle || createDefaultTextStyle(),
        textColor: data.ctaTextColor,
      }),
    ];
  }

  return [createDefaultHeroCta()];
};
